import React from "react";
import { Select } from "./Shared";
import { useScope } from "../lib/scope";
import { Buildings, MapPin } from "@phosphor-icons/react";

// Barra global de empresa/centro, visible en la parte superior de las pestañas que trabajan por centro.
export default function ScopeBar() {
  const s = useScope();
  if (!s) return null;
  return (
    <div className="mb-5 card-flat p-4 flex flex-col sm:flex-row sm:items-end gap-3" data-testid="scope-bar">
      <label className="block flex-1 min-w-0">
        <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500 mb-1"><Buildings size={13} /> Cliente / empresa</span>
        <Select value={s.companyId} onChange={(e) => s.setCompanyId(e.target.value)} data-testid="scope-company">
          <option value="">Todas las empresas</option>
          {s.companies.map((c) => <option key={c.id} value={c.id}>{c.nombre_comercial}</option>)}
        </Select>
      </label>
      <label className="block flex-1 min-w-0">
        <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500 mb-1"><MapPin size={13} /> Centro logístico / planta</span>
        <Select value={s.installId} onChange={(e) => s.setInstallId(e.target.value)} disabled={!s.companyId} data-testid="scope-installation">
          <option value="">{s.companyId ? "Todos los centros" : "Selecciona antes un cliente"}</option>
          {s.companyInstalls.map((i) => <option key={i.id} value={i.id}>{i.nombre}</option>)}
        </Select>
      </label>
    </div>
  );
}
